import {
  getIsValidEmail,
  getUserInfo,
  postNewStudent,
  getRoleList,
  getExistUser,
  getUserRoleList,
  getAuthCookie,
  logout,
  postNewStudentWithExcel,
  login,
} from "@/services/auth.service";

// initial state
const state = () => ({
  userRoleList: [],
  userInfo: {},
});

// mutations
const mutations = {
  setUserRoleList(state, data) {
    state.userRoleList = data;
  },
  setUserInfo(state, data) {
    state.userInfo = data;
  },
};

// actions
const actions = {
  //Authentication Swaggerv1
  async loadAuthCookie(vuexContext, data) {
    return await getAuthCookie(data).then((response) => {
      let data = response.data;
      return data;
    });
  },

  async loadUserInfo(vuexContext) {
    return await getUserInfo().then((response) => {
      let data = response.data.data;
      vuexContext.commit("setUserInfo", data);
      return data;
    });
  },

  async loadExistUser(vuexContext, data) {
    return await getExistUser(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadControlEmailResponse(vuexContext, email) {
    return await getIsValidEmail(email).then((response) => {
      let data = response.data.success;
      return data;
    });
  },

  async loadRoleList() {
    return await getRoleList().then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadUserRoleList(vuexContext) {
    return await getUserRoleList().then(async (response) => {
      let data = response.data.data || []; // Ensure data is not null
      vuexContext.commit("setUserRoleList", data);
      return data;
    });
  },

  //Authentication logout from sso
  async loadLogout() {
    return await logout().then(() => {
      location.href = "/login";
    });
  },

  async login(vuexContext, data) {
    return await login(data).then((response) => {
      return response;
    });
  },

  async postNewStudent(vuexContext) {
    let student = vuexContext.rootState.student.newStudentModel;
    let formData = new FormData();
    formData.append("Email", student.Email);
    formData.append("FirstName", student.FirstName);
    formData.append("LastName", student.LastName);
    formData.append("citiesId", student.citiesId);
    formData.append("NationalitysId", student.NationalitysId);
    formData.append("NationalitysId2", student.NationalitysId2);
    formData.append("NationalitysId3", student.NationalitysId3);
    formData.append("Tel", student.Tel);
    formData.append("Tel2", student.Tel2);
    formData.append("GenderId", student.GenderId);
    formData.append("DateOfBirth", student.DateOfBirth);
    formData.append("Adress", student.Adress);
    //formData.append("Code", student.Code);
    formData.append("PaidId", student.PaidId);
    formData.append("EducationTypeId", student.EducationTypeId);
    formData.append("LevelsId", student.LevelsId);
    formData.append("File", student.File);
    formData.append("CenterId", student.CenterId);
    formData.append("BirthPlace", student.BirthPlace);
    formData.append("CenterPeriodId", student.centerPeriodId);


    if (student.ClassId != null) formData.append("ClassId", student.ClassId);
    return await postNewStudent(formData);
  },

  async postNewStudentWithExcel(vuexContext, data) {
    return await postNewStudentWithExcel(data);
  },

  addUserRoleList(vuexContext, data) {
    vuexContext.commit("setUserRoleList", data);
  },

  addUserInfo(vuexContext, data) {
    vuexContext.commit("setUserInfo", data);
  },

  async checkMenuRole(vuexContext, menuRoles) {
    let isValidRequest = true;
    for await (let role of vuexContext.state.userRoleList) {
      if (menuRoles.indexOf(role) < 0) {
        // let containRole = vuexContext.state.userRoleList.find((s) => {
        //   return s == role;
        // });
        // if (!containRole) {
        isValidRequest = false;
      }
    }
    return isValidRequest;
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
